<div class="ui-g fluid">
  <div class="ui-g-12" style="margin-top: 0;">
    <div class="ui-g-12 background" >
      <div class="ui-g-1 ui-toolbar-group-left" (click)="back()" >
        <p-button class="btn-back"  type="p-button" icon="pi pi-angle-left"></p-button>
      </div>
      <div class="ui-g-8">
        <h2 class="title">Proveedores</h2>
      </div>
    </div>
    <div class="p-grid" >
      <div class="ui-g-12 ui-md-12 ui-sm-12" *ngIf="currentScreen == isProviders">
        <p-dataView #dv [value]="providers" [paginator]="true" [rows]="12" paginatorPosition="bottom" filterBy="idProvider.name,fullAddress" sortField="distance" [sortOrder]="1" layout="grid">
          <p-header>
              <div class="ui-g-12" style="margin: 1% 0; position: relative;" *ngIf="!doctorFilters">
                <input type="search" pInputText placeholder="Búsqueda por Nombre o Dirección" (input)="dv.filter($event.target.value, 'contains')">
                <i style="float: left; color: #073c8f;" class="pi pi-search search-icon"></i>
              </div>

              <div class="p-col p-grid" *ngIf="doctorFilters">
                <div class="p-col-12 p-md-12 p-lg-6 ui-fluid">
                    <!--<input style="width: 100%;" type="search" pInputText placeholder="Filtrar por Nombre o Dirección" [(ngModel)]="ipSearch" (input)="dv.filter(ipSearch, 'contains')">-->
                    <input style="width: 100%;" type="search" pInputText placeholder="Filtrar por Nombre" [(ngModel)]="ipSearch" (input)="regexFilter(ipSearch)">
                </div>
                <div class="p-col-12 p-md-6 p-lg-3 ui-fluid">
                    <p-autoComplete type="search"  [(ngModel)]="ipSearch0"  [suggestions]="specialtiesResult" field="strDescription" placeholder="Selecciona Especialidad" 
                    (completeMethod)="searchSpecialty($event)"
                    [dropdown]="true"></p-autoComplete>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3 ui-fluid">
                    <p-autoComplete type="search" class="search" [(ngModel)]="ipSearch1"   [suggestions]="subSpecialtiesResult" field="strDescription" placeholder="Selecciona SubEspecialidad" 
                    (completeMethod)="searchSubSpecialty($event)"
                    [dropdown]="true"  ></p-autoComplete>
                </div>
            </div>
          </p-header>
          <ng-template let-provider pTemplate="gridItem">
            <div class="ui-g-12 ui-md-6 ui-lg-4">
              <div class="provider-details">
                  <div class="ui-g-12" style="border-radius: 1em; background: #E8EAEE; min-height: 330px; display: flex;flex-direction: column; justify-content: space-between;">
                      <div class="ui-g-12"> <b>{{provider.idProvider.name}}</b></div>
                      <!--<div *ngIf="provider.telemedicine == true" class="ui-g-10 ui-sm-10"> <b>Telemedicina: {{provider.telemedicine}}</b></div>-->
                      <!--<div class="ui-g-10 ui-sm-10" >Estado: <b>{{provider.offline}}</b></div>
                      <div class="ui-g-10 ui-sm-10">Cola de Espera: <b>{{provider.queque}}</b></div>-->
                    <div class="ui-g-4 ui-md-4 ui-sm-2">
                      <b *ngIf="provider.distance != null">{{provider.distance}} Km</b>
                    </div>
                    <div class="ui-g-10 ui-md-10 ui-sm-10">
                      <div *ngFor="let specialty of provider.idProvider.specialty" > <b>{{specialty.strDescription}}</b></div>
                      <div *ngFor="let subspecialty of provider.idProvider.SubSpecialty" > <b>{{subspecialty.strDescription}}</b></div>
                    </div>
                    <div class="ui-g-10 ui-md-10 ui-sm-10">
                      <div class="address">{{provider.fullAddress}}</div>
                      <!--<div *ngIf="provider.telemedicine == true" class="ui-g-10 ui-sm-10"> <b>Telemedicina: {{provider.telemedicine}}</b></div>-->
                      <!--<div class="ui-g-10 ui-sm-10" >Estado: <b>{{provider.offline}}</b></div>
                      <div class="ui-g-10 ui-sm-10">Cola de Espera: <b>{{provider.queque}}</b></div>-->
                    </div>
                    <!--<div class="ui-g-2 ui-md-2 ui-sm-2">
                      <button pButton class="ui-button-success ui-widget ui-state-default" label="Ubicaciones"  icon="pi pi-angle-right" (click)="selectProvider($event, provider.idProvider)" ></button>
                    </div>-->
                    <div class="ui-g-12  ui-md-12 ui-sm-12">
                      <div class="ui-g-6 ui-md-6 ui-sm-6">
                        <button pButton type="button" label="Copagos" class="ui-button-primary ui-widget ui-state-default" icon="pi pi-caret-right" iconPos="left" (click)="cpayment(true, provider.idProvider)" style="width: 100%; font-weight: 400;"></button>
                      </div>
                      <div class="ui-g-6 ui-md-6 ui-sm-6">
                        <!--<button *ngIf="isOnline !== null && isOnline" pButton type="button" class="ui-button-primary ui-widget ui-state-default" style="width: 100%;" label="{{quequeVariable}}" (click)="waitList(true, provider)"></button>
                        <button *ngIf="isOnline !== null && !isOnline"  pButton  class="ui-button-primary ui-widget ui-state-default"  style="width: 100%;" label="Telemedicina" (click)="telemedicine(provider)" ></button>-->
                        <button pButton class="ui-button-success ui-state-default" label="Contacto y Horarios"  icon="pi pi-caret-right" (click)="selectProvider($event, provider)" style="border: none;" ></button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
    <div [hidden]="currentScreen!== isLocations" class="ui-g-12">
      <app-provider-location [infoProviders]="infoProviders" ></app-provider-location>
    </div>
    <div [hidden]="currentScreen !== isWait">
      <app-provider-wait [quequePosition]="quequePosition" [quequeTime]="quequeTime" [quequeVariable]="quequeVariable" [provider]="selectedProvider" ></app-provider-wait>
    </div>
  </div>
</div>
<p-dialog [closable]="true"  [(visible)]="copayment"  [modal]="false" [baseZIndex]="10000" [showHeader]="true"
          [style]="{width: '80vw'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
  <div class="ui-g-12 cardGray">
    <div class="ui-g-12" style="display: flex; align-items: center;">
      <div class="ui-g-2" style="margin: 0 auto;">
        <img src="../../assets/images/provider/copagos.png">
      </div>
    </div>
    <h2 class="title2">Consulta de copago</h2>
    <div *ngFor="let copay of copaymentInfo" style="margin: 10px 0px;" >
      <h3 class="subTitle" >{{copay["type"]}}</h3>
      <h2 class="copago">{{copay["description"]}}</h2>
    </div>
  </div>
</p-dialog>
<p-dialog [closable]="true"  [(visible)]="schedules"  [modal]="false" [baseZIndex]="10000" [showHeader]="true"
          [style]="{width: '80vw'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
          <div class="cardGray ui-g-12">
            <h2 class="title2">Consulta de Horarios y Contactos</h2>
            <div class="ui-g-12" *ngFor="let contact of contactOrms">
              <div class="ui-g-12">  <h4 class="subTitle">{{contact.idTypeContact.strDescription}}: </h4></div>
              <div class=" ui-g-12 p-grid">
                <div class="ui-g-3"></div>
                <div class="ui-g-12 ui-md-6 ui-lg-6 cardBlue3"> <h3 class="info">{{contact.strDescription}}</h3></div>
                <div class="ui-g-3"></div>
              </div>
            </div>
            <div *ngFor="let schedule of scheduleOrms">
              <h3 class="schedule">{{schedule.strDescription}}</h3>
            </div>
          </div>
</p-dialog>
<ng-template #thenBlock>
</ng-template>
<ng-template #elseBlock></ng-template>
<!--dialogo para mostrar la cola de espera y si desea esperar para continuar con el proceso de pago.-->
<!--

<p-dialog closable="true"  header="Espera" [(visible)]="displayWaitDialog"  [modal]="true" [showHeader]="false"
          [style]="{width: '80%', height:'80%'}"  [contentStyle]="{padding: '2em', textAlign: 'center'}">
  <div class="p-col-12 p-md-12" *ngIf="isOnline">
    <div>
      <h2>¡Esperando que la Doctora o Doctor acepte!</h2>
    </div>
    <div style="text-align: center; margin-top: 2%;">
      <i class="pi pi-user" style="font-size: 3em;"></i>
    </div>
    <h3>Personas en cola</h3>
    <h2 style="color: #0f5feb; font-size: 28px;">{{quequePosition}}</h2>
    <div style="text-align: center; margin-top: 2%;">
      <i class="pi pi-clock" style="font-size: 3em;"></i>
    </div>
    <h3>Tiempo aproximado de espera:</h3>
    <h2 style="color: #0f5feb; font-size: 28px;">{{quequeTime}} minutos</h2>
    <div style="margin: 2% 0">
      <h2>¿Desea esperar?</h2>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-5">
        <button  pButton type="button" class="ui-button-danger btn-dv" style="width: 60%;" label="Cancelar" (click)="waitList(false)"></button>
      </div>
      <div class="ui-g-5">
        <button  pButton type="button" class="ui-button-secondary btn-dv" style="width: 60%;" label="Siguiente" (click)="cpayment(true)"></button>
      </div>
    </div>
  </div>
</p-dialog>
&lt;!&ndash;dialogo para mostrar el copago.&ndash;&gt;
&lt;!&ndash;dialogo para solicitar pago.&ndash;&gt;
<div>

</div>
<p-dialog closable="true"  [(visible)]="dialogCreditCard" [modal]="false" [maximizable]="true" [showHeader]="false"
          [contentStyle]="{padding: '5em', textAlign: 'center'}">
  <ng-payment-card
    ccNumMissingTxt="Please provide card number"
    cardExpiredTxt="Payment card has expired"
    [validateCardExpiration]="true"
    [validateCCNum]="true"
    [validateCCV]="true"
    (formSaved)="processPayment($event)">
  </ng-payment-card>
</p-dialog>-->
